import React from "react";
import { string } from "prop-types";

import * as S from "./styled";

const ConfirmationModalMessage = ({ agentName }) => (
  <S.ConfirmationTextContainer>
    <b>What’s next?</b>
    <br />
    You’re all set. {agentName} will be in touch shortly.
  </S.ConfirmationTextContainer>
);

ConfirmationModalMessage.propTypes = {
  agentName: string.isRequired
};

export default ConfirmationModalMessage;
